import { useContext } from "react";
import Header from "../component/header";
import Banner from "../component/Banner";
import Misson from "../component/Ourmission";
import Core from "../component/Corepillars";
import Gallery from "../component/Gallery";
import Cricle from "../component/Circle";
import Craft from "../component/Craft";
import Challenges from "../component/Challenges";
import Growth from "../component/Growth";
import Community from "../component/Community";
import Spotlight from "../component/Spotlight";
import Motion from "../component/Form";
import Footer from "../component/Footer";
import { UserDataContext } from "../context/User";
import BannerImg from "../image/backgroundbanner.png";

const Home = () => {
  const { userData } = useContext(UserDataContext);
  const isLoggedIn = userData?.id;

  return (
    <div className="App">
      <Header />
      <Banner
        backgroundImage={BannerImg}
        heading="Welcome to a nurturing haven where photographers and sculptors can reignite their sidelined creative passions"
        paragraph="We empower diverse artists-especially under-represented voices-to grow and pursue their passions. Join us to amplify your talents, foster equity, and uplift all. Your passion belongs here!"
        minHeight="100vh"
        padding="80px 0"
        bton="Members please sign-in"
      />

      {isLoggedIn ? (
        <>
          <Gallery maxItems={4} />
          <Craft userData={userData} />
          <Growth />
          <Challenges />
          <Community />
          <Misson />
        </>
      ) : (
        <>
          <Misson />
          <Core />
          <Gallery maxItems={4} />
          <Craft userData={userData} />
          <Cricle />
          <Challenges />
          <Growth />
          <Community />
          <Spotlight />
        </>
      )}

      <Footer />
    </div>
  );
};

export default Home;
